/**
 * Parse community id from the url.
 * Prefer to use communityId from `useContext(CommunityContext)` whenever possible.
 * @returns communityId
 */
export const getCommunityId = (): string =>
  window.location.pathname.split('/')[1].toLowerCase() || '';
